import {getBlockAbove} from "./getBlockAbove.js";
import {isStart} from "./isStart.js";
export const isSelectionAtBlockStart = (editor) => {
  const path = getBlockAbove(editor)?.[1];
  return !!path && isStart(editor, editor.selection?.focus, path);
};
